import type { PresencePayload } from '../../../services/messaging/presenceService';
import { CollaboratorLink } from '../../collaborators/CollaboratorLink';

interface Props {
  presence: PresencePayload[];
}

function initials(fullName: string): string {
  const parts = fullName.trim().split(/\s+/);
  return parts
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
}

export function PresencePanel({ presence }: Props) {
  if (presence.length === 0) {
    return (
      <div className="px-3 py-3 text-xs text-cime-text-muted italic">
        Personne d'autre n'est en ligne.
      </div>
    );
  }

  return (
    <div className="px-3 py-2 border-b border-neutral-200">
      <h3 className="text-[10px] font-semibold uppercase tracking-wider text-cime-text-muted mb-2">
        En ligne
      </h3>
      <ul className="space-y-1.5 max-h-[120px] overflow-y-auto">
        {presence.map((p) => (
          <li key={p.collaborator_id} className="flex items-center gap-2 text-xs">
            <CollaboratorLink collaboratorId={p.collaborator_id} title={`Voir le profil de ${p.full_name}`}>
              <div className="relative flex-shrink-0">
                {p.avatar_url ? (
                  <img
                    src={p.avatar_url}
                    alt=""
                    className="w-7 h-7 rounded-full object-cover"
                  />
                ) : (
                  <div className="w-7 h-7 rounded-full bg-neutral-200 flex items-center justify-center text-[10px] font-medium text-neutral-700">
                    {initials(p.full_name)}
                  </div>
                )}
                <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-cime-success border-2 border-white" />
              </div>
            </CollaboratorLink>
            <div className="min-w-0 flex-1">
              <CollaboratorLink collaboratorId={p.collaborator_id} title={`Voir le profil de ${p.full_name}`}>
                <div className="font-medium text-cime-text-primary truncate">
                  {p.full_name}
                </div>
              </CollaboratorLink>
              {p.context_label && (
                <div className="text-cime-text-muted truncate">
                  {p.context_label}
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
